import { Routes } from '@angular/router';
import { MainLayout } from './core/layouts/main-layout/main-layout';
import { authGuard, noAuthGuard } from './features/auth/auth.guard';
import { Login } from './features/auth/login/login';
import { ForgotPassword } from './forgot-password/forgot-password';
import { isShareApp } from './core/utils/domain.util';
export const routes: Routes = [
  ...(!isShareApp()
    ? [
        {
          path: 'login',
          component: Login,
          canActivate: [noAuthGuard],
        },

        {
          path: 'reset-password',
          component: ForgotPassword,
          canActivate: [noAuthGuard],
        },
      ]
    : []),

  {
    path: 'mis-mediciones/mis-datos',
    loadComponent: () => import('./measurements/measurements').then((m) => m.Measurements),
  },
  {
    path: 'confirmar-datos-contacto',
    loadComponent: () => import('./confirm-data/confirm-data').then((m) => m.ConfirmData),
  },

  ...(!isShareApp()
    ? [
        {
          path: '',
          component: MainLayout,
          canActivate: [authGuard],
          children: [
            // ejemplo en app-routing (o el modulo de backoffice)
            {
              path: '',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/home/home-page/home-page').then((m) => m.HomePage),
            },
            {
              path: 'administradores',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/administrator/administrators-page/administrators-page').then(
                  (m) => m.AdministratorsPage,
                ),
            },

            {
              path: 'perfil/datos-personales',
              loadComponent: () =>
                import('./features/profile/profile-personal-data/profile-personal-data').then(
                  (m) => m.ProfilePersonalData,
                ),
            },
            {
              path: 'perfil/restablecer-clave',
              loadComponent: () =>
                import('./features/profile/reset-pass/reset-pass').then((m) => m.ResetPass),
            },
            {
              path: 'profesionales',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/professionals/professional-page/professional-page').then(
                  (m) => m.ProfessionalPage,
                ),
            },
            {
              path: 'usuarios',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/users/users-page/users-page').then((m) => m.UsersPage),
            },
            {
              path: 'tyc',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () => import('./features/tyc/tyc/tyc').then((m) => m.Tyc),
            },
            {
              path: 'privacidad',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/privacy/privacy/privacy').then((m) => m.Privacy),
            },
            {
              path: 'planes-empresariales',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/companies/companies/companies').then((m) => m.Companies),
            },
            {
              path: 'planes',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/plans/plans-page/plans-page').then((m) => m.PlansPage),
            },
            {
              path: 'pacientes',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/patient/patients-page/patients-page').then(
                  (m) => m.PatientsPage,
                ),
            },
            {
              path: 'suscripciones',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/subscriptions/subscriptions-page/subscriptions-page').then(
                  (m) => m.SubscriptionsPage,
                ),
            },

            {
              path: 'vinculos',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/users-ties/users-page/users-ties-page').then(
                  (m) => m.UsersTiesPage,
                ),
            },
            {
              path: 'categoria',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/categories/categories-page/categories-page').then(
                  (m) => m.CategoriesPage,
                ),
            },
            {
              path: 'faqs',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/faqs/faqs-page/faqs-page').then((m) => m.FaqsPage),
            },
            {
              path: 'validaciones',
              loadComponent: () =>
                import('./features/validator/validator').then((m) => m.Validator),
            },
            {
              path: 'boton-panico',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/panic/panic-events/panic-events').then((m) => m.PanicEvents),
            },
            {
              path: 'configuracion-boton-panico',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/panic-configuration/panic-configuration/panic-configuration').then(
                  (m) => m.PanicConfiguration,
                ),
            },
            {
              path: 'pagos',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/payments/payments/payments').then((m) => m.PaymentsPage),
            },
            {
              path: 'pacientes',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/patient/patients-page/patients-page').then(
                  (m) => m.PatientsPage,
                ),
            },
            {
              path: 'config/obras-sociales',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/coverage/coverage-page/coverage-page').then(
                  (m) => m.CoveragePage,
                ),
            },
            {
              path: 'config/planes',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/coverage-plans/coverage-plans-page/coverage-plans-page').then(
                  (m) => m.CoveragePlansPage,
                ),
            },
            {
              path: 'familia',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/family/family-page/family-page').then((m) => m.FamilyPage),
            },
            {
              path: 'roles',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/roles/roles-page/roles-page').then((m) => m.RolesPage),
            },
            {
              path: 'config/subespecialidades',
              // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
              loadComponent: () =>
                import('./features/subspecialties/subspecialties-page/subspecialties-page').then(
                  (m) => m.SubSpecialtiesPage,
                ),
            },
            { path: '**', redirectTo: '' },
          ],
        },
      ]
    : []),

  {
    path: '**',
    redirectTo: 'mis-mediciones/mis-datos',
  },
];
